<template>
    <ComplainList/>
</template>

<script>
import { ComplainList } from 'shared'

export default {
    name: 'complainList',
    components: {
        ComplainList
    }
}
</script>